// Focus only authoritative server feedback after native form-fragment navigation.
if (!customElements.get('tb-pages-contact')) {
  customElements.define('tb-pages-contact', class extends HTMLElement {
    constructor() {
      super();
      this.frame = 0;
      this.controller = null;
      this.handled = false;
    }

    connectedCallback() {
      this.cleanup();
      if (this.handled) return;
      const form = this.querySelector('form');
      const feedback = form?.querySelector('[data-contact-feedback]');
      if (!feedback || location.hash !== '#' + form.id) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const active = document.activeElement;
          if (this.isConnected && location.hash === '#' + form.id &&
              (!active || active === document.body || active === form || active === feedback)) {
            feedback.focus();
            this.handled = true;
          }
          this.cleanup();
        });
      };
      // pageshow/load finish before the next frame and native fragment focus settles.
      window.addEventListener('load', schedule, { once: true, signal });
      window.addEventListener('pageshow', schedule, { once: true, signal });
      window.addEventListener('hashchange', schedule, { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.cleanup(), { signal });
      if (document.readyState === 'complete') schedule();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.controller?.abort();
      this.controller = null;
    }
  });
}
